import "./App.css";
import { Layout } from "./layout/layout";
import { Home } from "./home/home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { About } from "./about/about";
import { Details } from "./details/details";
import ScrollToTop from "./scrollToTop/scrollToTop";
import { Contact } from "./contact/contact";
import { useState } from "react";
import { Loader } from "./loader/loader";

function App() {
  const [loading, setLoading] = useState(true);
  setTimeout(() => {
    setLoading(false);
  }, 1500);

  if (loading) return <Loader />;

  return (
    <Layout>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/details" element={<Details />}></Route>
          <Route path="/contact" element={<Contact />}></Route>
        </Routes>
      </BrowserRouter>
    </Layout>
  );
}

export default App;
